import { EventEmitter, Injectable } from '@angular/core';
import { CotacaoAutoService } from './cotacao-auto.service';
import { CotacaoAcidentesPessoaisService } from './cotacao-acidentes-pessoais.service';
import { CotacaoVidaService } from './cotacao-vida.service';
import { CotacaoVidaGlobalService } from './cotacao-vida-global.service';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { RamosCodes } from 'src/app/models/ramosCodes.model';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { UtilsService } from '../utils.service';
import { CotacaoPacoteService } from './cotacao-pacote.service';
import { CotacaoCondominioService } from './cotacao-condominio.service';
import { PdocsService } from '../pdocs.service';
import { SharedMemoryService } from '../shared-memory.service';
import { ApiApiceService } from '../api/api-apice.service';
import { ApiInterfaceService } from '../api/api-interface.service';
import { CalcAuto } from 'src/app/models/calcAuto.model';
import { CalcAcidentesPessoais } from 'src/app/models/calcAcidentesPessoais.model';
import { CalcPacote } from 'src/app/models/calcPacote.model';
import { CalcVida } from 'src/app/models/calcVida.model';
import { CalcVidaGlobal } from 'src/app/models/calcVidaGlobal.model';
import { BehaviorSubject} from 'rxjs';
import { CalcViagem } from 'src/app/models/calcViagem.model';
import { CotacaoViagemService } from './cotacao-viagem.service';
import { CalcBike } from 'src/app/models/calcBike.model';
import { CotacaoBikeService } from './cotacao-bike.service';
import { CalcAluguel } from 'src/app/models/calcAluguel.model';
import { CotacaoAluguelService } from './cotacao-aluguel.service';
import { SeguradorasBase } from 'src/app/models/seguradoras/factory/base.model';

@Injectable({
  providedIn: 'root'
})

export class CotacaoService {

  private cotacaoRamoService: CotacaoRamoService;
  private ramo: number;
  private _ramos: RamosCodes = IntegracaoConstants.ramos;
  private screenshotSubject = new BehaviorSubject<boolean>(false);
  private _seguradorasBase: SeguradorasBase = IntegracaoConstants.seguradoras;
  intermediario = new EventEmitter();
  recalculoEmiter = new EventEmitter();
  copiarModal = new EventEmitter();

  constructor(
    private cotacaoAutoService: CotacaoAutoService,
    private cotacaoAcidentesPessoaisService: CotacaoAcidentesPessoaisService,
    private cotacaoVidaService: CotacaoVidaService,
    private cotacaoVidaGlobalService: CotacaoVidaGlobalService,
    private cotacaoCondominioService: CotacaoCondominioService,
    private cotacaoPacoteService: CotacaoPacoteService,
    private cotacaoViagemService: CotacaoViagemService,
    private cotacaoAluguelService: CotacaoAluguelService,
    private cotacaoBikeService: CotacaoBikeService,
    private pdocsService: PdocsService,
    private sharedMemoryService: SharedMemoryService,
    private utilsService: UtilsService) { }

  clear() {
    this.cotacaoRamoService = null;
    this.ramo = null;
  }

  setComissaoDefault(su, ramo) {
    this.initialize(ramo);
    if(ramo == this._ramos.EMPRESARIAL || ramo == this._ramos.RESIDENCIAL)
      this.cotacaoRamoService.setComissaoDefault(su, ramo);
    else
      this.cotacaoRamoService.setComissaoDefault(su);
  }

  loaderIntermediario(valor){
    this.intermediario.emit(valor);
  }

  enviaRecalculo(json) {
    this.recalculoEmiter.emit(json);
  }

  getColumnsGridCalculosVersao(ramo) {
    this.initialize(ramo);
    return this.cotacaoRamoService.getColumnsGridCalculosVersao();
  }

  createVersions(arrayVersions, ramo) {
    this.initialize(ramo);
    return this.cotacaoRamoService.createVersions(arrayVersions);
  }

  async createDraft(negocio, ramo, api) {

    let seg = null;
    let params: any = {};

    if (ramo) {
      this.initialize(ramo);
      if (!negocio) {
        params = this.utilsService.getUrlParams();
        if (params.seguradoId) {
          seg = await api.getSeguradoById(params.seguradoId);
        }
      }

      let draft = this.cotacaoRamoService.createDraft(negocio, { seguradoUrl: seg, negocioUrl: params.negocioId });

      if (draft)
        draft.integracaoInfo = 1;

      return draft;

    } else
      return null;

  }

  setCoberturas(v, obj) {
    return this.cotacaoRamoService.setCoberturas(v, obj);
  }

  async setDadosUser(ramo){

     if (this.cotacaoRamoService == null)
         this.initialize(ramo)

      if (
        this.cotacaoRamoService instanceof CotacaoAutoService ||
        this.cotacaoRamoService instanceof CotacaoVidaService||
        this.cotacaoRamoService instanceof CotacaoPacoteService ||
        this.cotacaoRamoService instanceof CotacaoCondominioService || 
        this.cotacaoRamoService instanceof CotacaoAcidentesPessoaisService ||
        this.cotacaoRamoService instanceof CotacaoViagemService ||
        this.cotacaoRamoService instanceof CotacaoAluguelService ||
        this.cotacaoRamoService instanceof CotacaoBikeService
       )
        await this.cotacaoRamoService.setDadosUser()
  }

  async verCalcSeguradora(api, pacoteSelecionado, arraySegs, ramo, isError, cpfCnpj = null) {
    this.initialize(ramo);
    // debugger;
    if (isError) {
      await this.utilsService.createAlert('Atenção', 'Não é possível visualizar um cálculo com erro na seguradora.');
    } else {
      let info = arraySegs.find(function (rs) { return rs.idPacote == pacoteSelecionado });

        if (!info.idIntegracaoCfgSeg)
          info.idIntegracaoCfgSeg = info.idIntegracaoCfg;

        // debugger;
        let msgExt = this.cotacaoRamoService.getMessageCalcExtension(this.ramo);

        api.getCfgSeg(info.idIntegracaoCfgSeg).then(async (ret: any) => {
          //adaptado para o ápice
          if (ret) {
            // debugger
            let configsSeg = ret?.configsSeg;
            delete ret.configsSeg;
            var calc = ret;
            calc.cpfCnpj = cpfCnpj;
            calc.login = calc.login;
            calc.senha = calc.senha;
            calc.numeroRef = info.nroCalculo;
            calc.seguradora = info.seguradora;

            calc = {...calc, ...configsSeg};
            // console.log('VER SEGURADORA JSON', JSON.stringify(calc, null, 4));
            //let msgExt = this.cotacaoRamoService.getMessageCalcExtension();

            if (calc.seguradora === this._seguradorasBase.JUSTOS.id) 
              calc.justosToken = await api.getTokenJustos(calc.usuario);

            window.postMessage({ type: msgExt, text: JSON.stringify(calc) }, "*");

          } else {
            if(ret.message == "É necessário estar logado no Multi para utilizar esta função.") {
              // this.pdocsService.clear();
              // this.sharedMemoryService.set('wakUser', null);
              debugger;
            }
            await this.utilsService.createAlert("Atenção", "Não foi possível recuperar as credenciais de acesso deste cálculo.");
          }

        }).catch(async (error) => {
          console.log('error buscar credenciais', error);
          await this.utilsService.createAlert("Atenção", "Não foi possível recuperar as credenciais de acesso deste cálculo.");
        });
    }

  }

  matStepRoute(action, selectedStep, flags) {
    return this.cotacaoRamoService.matStepRoute(action, selectedStep, flags);
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, ramo, estadoSegurado?) {
    return this.cotacaoRamoService.getSeguradorasStatus(seguradorasUser, servicesInfos, ramo, estadoSegurado);
  }

  //adaptado para o ápice
  async getCoberturasUser(api) {
    try {
      let coberturas = await  this.cotacaoRamoService.getCoberturasUser(api);
      if(coberturas){
        coberturas = Object.keys(coberturas).map(index => coberturas[index]);
        for(let cober of coberturas){
          if(cober.pacote == 'prata'){
            cober['tipoCobertura'] = 1;
          }else if(cober.pacote == 'ouro'){
            cober['tipoCobertura'] = 2;
          }else if(cober.pacote == 'diamante'){
            cober['tipoCobertura'] = 3;
          }
        }
        coberturas[0].default = true;
        return coberturas;
      } else {
        return null;
      }
    } catch (error) {
      console.log('error getCoberturasUser', error);
      throw error;
    }
  }

  coberturasMerge(coberturas, obj) {
    return this.cotacaoRamoService.coberturasMerge(coberturas, obj);
  }

  getCalcObject(draft, seguradoras, coberturas) {
    return this.cotacaoRamoService.getCalcObject(draft, seguradoras, coberturas);
  }

  updateResults(versao) {
    return this.cotacaoRamoService.updateResults(versao);
  }

  sessoesPDF() {
    return this.cotacaoRamoService.sessoesPDF();
  }

  private initialize(ramo) {
    switch (ramo) {
      case this._ramos.AUTO: this.cotacaoRamoService = this.cotacaoAutoService; break;
      case this._ramos.VIDA: this.cotacaoRamoService = this.cotacaoVidaService; break;
      case this._ramos.VIDA_GLOBAL: this.cotacaoRamoService = this.cotacaoVidaGlobalService; break;
      case this._ramos.ACIDENTES_PESSOAIS: this.cotacaoRamoService = this.cotacaoAcidentesPessoaisService; break;
      case this._ramos.RESIDENCIAL:
      case this._ramos.EMPRESARIAL: this.cotacaoRamoService = this.cotacaoPacoteService; break;
      case this._ramos.CONDOMINIO: this.cotacaoRamoService = this.cotacaoCondominioService; break;
      case this._ramos.VIAGEM: this.cotacaoRamoService = this.cotacaoViagemService; break;
      case this._ramos.ALUGUEL: this.cotacaoRamoService = this.cotacaoAluguelService; break;
      case this._ramos.BIKE: this.cotacaoRamoService = this.cotacaoBikeService; break;
    }
    this.ramo = ramo;
  }

  isAllCalcsReady(version) {

    let ready = true;
    let types = ['main', 'alternatives', 'porAssinatura'];
    types.forEach(function (t) {
      version.results[t].successes.forEach((r) => {
        if (!r.retorno)
          ready = false;
      });
      version.results[t].errors.forEach((r) => {
        r.msErros.find(erro =>
          erro.match(/Tentativa\s[1-2]\/3/gm) && (ready = false)
        );
      });
    }.bind(this));

    return ready;
  }

  clearResults(version) {

    let types = ['main', 'alternatives', 'porAssinatura', 'all'];
    let status = ['successes', 'errors'];

    if (version)
      types.forEach(function (t) {
        status.forEach(function (s) {
          version.results[t][s] = [];
        }.bind(this));
      }.bind(this));

  }

  modalCopiarblockAlert(valor) {
    this.copiarModal.emit(valor)
  }

  geraJsonCopia(draft) {
    let json;
    let campoPreencherJson = IntegracaoConstants.camposCopiarCotacao;
    if (this.ramo == this._ramos.AUTO)
      json = new CalcAuto();
    else if (this.ramo == this._ramos.RESIDENCIAL || this.ramo == this._ramos.EMPRESARIAL || this.ramo == this._ramos.CONDOMINIO)
      json = new CalcPacote();
    else if (this.ramo == this._ramos.VIDA)
      json = new CalcVida();
    else if (this.ramo == this._ramos.VIDA_GLOBAL)
      json = new CalcVidaGlobal();
    else if (this.ramo == this._ramos.ACIDENTES_PESSOAIS)
      json = new CalcAcidentesPessoais();
    else if (this.ramo == this._ramos.VIAGEM)
      json = new CalcViagem();
    else if (this.ramo == this._ramos.ALUGUEL)
      json = new CalcAluguel();
    else if (this.ramo == this._ramos.BIKE)
      json = new CalcBike();
    campoPreencherJson.forEach(campo => { draft.hasOwnProperty(campo) ? json[campo] = draft[campo] : null });
    return json;
  }

  get screenshot() {
    return this.screenshotSubject.asObservable();
  }

  updateScreenshot(value: boolean) {
    this.screenshotSubject.next(value);
  }

}
